import { Route, Routes } from 'react-router-dom'
import { Home } from '../components/Login/index'
import Deudas from '../components/ListDebts'
import ModalUserNotDebts from '../components/ModalUserNotDebts'
import ModalPayDebts from '../components/ModalPayDebts'
import ModalErrorMedpay from '../components/ModalErrorMedpay'
import ModalErrorClient from '../components/ModalErrorClient'
import ModalErrorDisconnect from '../components/ModalErrorDisconnect'
import PaymentConfirm from '../components/PaymentConfirm'
import ModalErrorTimeOut from '../components/ModalErrorTimeOut'
import PageNotFound from '../components/ModalPageNotFound'

export const AppRouter = () => {
  return (
    <>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/listDebts' element={<Deudas />} />
        <Route path='/noDebt' element={<ModalUserNotDebts />} />
        <Route path='/errorClient' element={<ModalErrorClient />} />
        <Route path='/disconnect' element={<ModalErrorDisconnect />} />
        <Route path='/listDebts/payDebts' element={<ModalPayDebts />} />
        <Route path='/listDebts/disconnect' element={<ModalErrorMedpay />} />
        <Route path='/payment/confirmation/' element={<PaymentConfirm />} />
        <Route path='/expired/session' element={<ModalErrorTimeOut />} />
        <Route path='*' element={<PageNotFound />} />
      </Routes>
    </>
  )
}
